'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AVATAR = exports.AVATAR = ['avatar'];
var FIRST_NAME = exports.FIRST_NAME = ['firstName'];
var LAST_NAME = exports.LAST_NAME = ['lastName'];
var IS_BOT = exports.IS_BOT = ['bot'];
var USER_ID = exports.USER_ID = ['userId'];
var IS_ONLINE = exports.IS_ONLINE = ['online'];
var EMAIL = exports.EMAIL = ['email'];
var AGENT_TYPE = exports.AGENT_TYPE = ['agentType'];
var MEETINGS_LINKS_TEXT = exports.MEETINGS_LINKS_TEXT = ['meetingsLinkText'];
var MEETINGS_LINKS_URL = exports.MEETINGS_LINKS_URL = ['meetingsLinkUrl'];